<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="text-h5 font-weight-black orange--text mb-6">FAQ's</h1>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="(q,i) in faqs"
      :key="i"
      class="mb-4"
      style="border-radius:5px;"
      v-animate-onscroll="'animate__animated animate__zoomIn'"
      v-on:animationend="removeClass($event)"
    >
      <v-expansion-panel-header>{{q.q}}</v-expansion-panel-header>
      <v-expansion-panel-content>
        {{q.a}}
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</v-col>
</v-row>
</v-container>
</template>
<script type="text/javascript">
  export default{
      data(){
        return {
          faqs:[
            {
              q:'What is GroCart?',
              a:'GroCart is a product specially designed for local grocery, fruit and vegetable sellers, and other small retailers dealing with the basic essential needs of any customer.'
            },
            {
              q:'How much I have to Pay?',
              a:'We are offering three different plans. Based on your convenience and business size, you could choose anyone of them.'
            },
            {
              q:'Do I have to pay a setup fee every year?',
              a:'No. It is a one-time fee.'
            },
            {
              q:'Could I use my own logo and a brand name?',
              a:'Yes, of course.'
            },
            {
              q:'Will my application be available on the Google Play store?',
              a:'Yes. Your user application will be available on the google play store.'
            },
            {
              q:'What about support after sales?',
              a:'We believe in long term business and follow this in our business model. We provide you all-time support.'
            }
          ]
        }
      },
      mounted(){
        
      },
      methods:{
        removeClass(e){
          console.log(e)
        }
      }
  }
</script>